import {
  achievementsPage,
  adminSettingsUrl,
  askMeAnythingPagePathname,
  campaignUrl,
  creatorImpactPath,
  digestPath,
  eventPagePathname,
  feedPageUrl,
  groupFeedRedirectPage,
  leaderDashboardPageUrl,
  leadershipCornerPageUrl,
  newFollowersPath,
  questionUrl,
  questionsPageUrl,
  storylinePublisherPageByOfficeUserId,
  storylinesPageUrl,
  suggestedConnectionsPath,
  threadPage,
  topicPage,
  userPage,
  userStorylinePage,
} from '../../urls';

import type { DeepLinkTargetType, DeepLinkType } from './types';
import { userAchievementPageUrlFromEntityId } from './userAchievementPageUrlFromEntityId';

interface GetDeepLinkTargetPathProps {
  readonly targetType: DeepLinkTargetType;
  readonly targetInstance?: string;
  readonly deepLinkType: DeepLinkType;
}
type GetDeepLinkTargetPath = ({ targetType, targetInstance, deepLinkType }: GetDeepLinkTargetPathProps) => string;

const getThreadPath = (targetInstance: string, deepLinkType: DeepLinkType): string =>
  deepLinkType === 'crossapp' ? threadPage(targetInstance) : threadPage(targetInstance, { showMoreForYou: true });

const getQuestionPath = (targetInstance: string, deepLinkType: DeepLinkType): string =>
  deepLinkType === 'crossapp' ? questionUrl(targetInstance) : questionUrl(targetInstance, { showMoreForYou: true });

const getUserAchievementPath = (targetInstance: string, deepLinkType: DeepLinkType): string =>
  deepLinkType === 'crossapp' ? achievementsPage(targetInstance) : userAchievementPageUrlFromEntityId(targetInstance);
// eslint-disable-next-line complexity
export const getDeepLinkTargetPath: GetDeepLinkTargetPath = ({ targetType, targetInstance = '', deepLinkType }) => {
  switch (targetType) {
    case 'event':
      return eventPagePathname(targetInstance);
    case 'group':
      return groupFeedRedirectPage(targetInstance);
    case 'home':
      return feedPageUrl;
    case 'thread':
      return getThreadPath(targetInstance, deepLinkType);
    case 'topic':
      return topicPage(targetInstance);
    case 'user':
      return userPage(targetInstance);
    case 'officeuserstorylinepublisher':
      return storylinePublisherPageByOfficeUserId(targetInstance);
    case 'storyline':
      return storylinesPageUrl;
    case 'userstoryline':
      return userStorylinePage(targetInstance, { storylineIntroPage: true });
    case 'newfollowers':
      return newFollowersPath;
    case 'suggestedconnections':
      return suggestedConnectionsPath;
    case 'leaderdashboard':
      return leaderDashboardPageUrl;
    case 'leadershipcorner':
      return leadershipCornerPageUrl;
    case 'question':
      return getQuestionPath(targetInstance, deepLinkType);
    case 'questionspage':
      return questionsPageUrl;
    case 'userachievement':
      return getUserAchievementPath(targetInstance, deepLinkType);
    case 'admin':
      return adminSettingsUrl;
    case 'campaign':
      return campaignUrl(targetInstance);
    case 'askmeanything':
      return askMeAnythingPagePathname(targetInstance);
    case 'digest':
      return targetInstance ? `/digest/${targetInstance}` : digestPath;
    case 'creatorimpact':
      return creatorImpactPath;
    default:
      throw new Error('getDeepLinkTargetPath Unsupported targetType');
  }
};
